import ApiService from '@/core/api/api.service';

import { functionsWithNotifications } from '@/core/notifications';
import feedbackMessages from './feedback.messages';

const functions = {
  create,
};

export default {
  ...functionsWithNotifications(functions, feedbackMessages),
};

const feedbackApi = new ApiService();

async function create(feedback) {
  return feedbackApi.post('feedbacks', { feedback });
}
